import { lazy } from "react";

// project import
// import GuestGuard from 'utils/route-guard/GuestGuard';
// import CommonLayout from 'layout/CommonLayout';
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// render
const AddStore = Loadable(lazy(() => import("pages/shops/add-store")));
const Stores = Loadable(lazy(() => import("pages/shops/stores")));
const Products = Loadable(lazy(() => import("pages/shops/products")));
const Notifications = Loadable(lazy(() => import("pages/notification")));

const StoreRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "stores",
      children: [
        {
          path: "",
          element: <Stores />,
        },
        {
          path: ":id",
          element: <Products />,
        },
      ],
    },
    {
      path: "add-store",
      element: <AddStore />,
    },
    {
      path: "notifications",
      element: <Notifications />,
    },
  ],
};

export default StoreRoutes;
